"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Qualifiers = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _detailsTabs = require("../common/details-tabs");

var _details = require("./details");

var _underlineTable = require("../common/underline-table");

var _qualifiersList = require("../common/qualifiers-list");

var _jsxRuntime = require("react/jsx-runtime");

var ThreeColumnUnderlineTable = (0, _underlineTable.createUnderlineTable)({
  gridTemplateColumns: '1fr 1fr 1fr',
  cellPadding: '8px'
});

var QualifierWrapper = _styledComponents["default"].div.withConfig({
  displayName: "QualifierWrapper",
  componentId: "sc-1ozi0c4-0"
})(["&&{> *{margin:24px 0;}}"]);

var Qualifiers = function Qualifiers(_ref) {
  var loanOffer = _ref.loanOffer,
      shownTab = _ref.shownTab,
      handleShownTab = _ref.handleShownTab,
      showExtrapolatedToolTip = _ref.showExtrapolatedToolTip;
  var title = _details.QUALIFICATION_REQUIREMENTS;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.MobileTab, {
      shownTab: shownTab,
      handleShownTab: handleShownTab,
      title: title
    }), title === shownTab && /*#__PURE__*/(0, _jsxRuntime.jsxs)(QualifierWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
        bold: true,
        children: "Here's what you need to qualify:"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ThreeColumnUnderlineTable, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_qualifiersList.QualifiersList, {
          qualifiers: loanOffer.qualifiers,
          showExtrapolatedToolTip: showExtrapolatedToolTip
        })
      })]
    })]
  });
};

exports.Qualifiers = Qualifiers;
//# sourceMappingURL=qualifiers.js.map